import {
  Button,
  Box,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.scss";
import { EffectCube, Pagination } from "swiper";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  tutorial: {
    "& .MuiToolbar-root": {
      background: "#f8f8f8",
    },
    "& .tutorialSwiper": {
      with: "100%",
      height: "calc(100vh - 52px)",
      background: "#f8f8f8",
      paddingBottom: 0,
      "& .swiper-wrapper": {
        "& .swiper-slide": {
          boxSizing: "border-box",
          padding: `${rem(50)} 0 ${rem(80)}`,
          "-webkit-backface-visibility": "hidden",
          "- webkit - transform": "translate3d(0, 0, 0)",
          "& dl": {
            textAlign: "center",
            "& dt": {
              fontSize: rem(22),
              fontWeight: 700,
              lineHeight: rem(32),
              letterSpacing: "-0.8px",
            },
            "& dd": {
              fontSize: rem(14),
              fontWeight: 300,
              lineHeight: rem(22),
              marginTop: rem(10),
            },
          },
          "& .tutorialImg": {
            marginTop: rem(27),
            textAlign: "center",
            height: "calc(100% - 183px)",
            "& img": {
              height: "100%",
            },
          },
        },
      },
      "& .swiper-pagination": {
        bottom: "auto",
        top: rem(-6),
        "& .swiper-pagination-bullet": {
          width: rem(5),
          height: rem(5),
          opacity: 1,
          background: "#dfdfdf",
          margin: `0 ${rem(3)}`,
          "&.swiper-pagination-bullet-active": {
            width: rem(12),
            background: "#8e8e8e",
            borderRadius: rem(3),
          },
        },
      },
      "& .swiper-button-prev": {
        display: "none",
      },
      "& .swiper-button-next": {
        width: "100%",
        height: rem(80),
        top: "auto",
        bottom: 0,
        left: 0,
        right: 0,
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        "&:after": {
          content: "'다음'",
          fontSize: rem(18),
          fontWeight: 700,
          letterSpacing: "-0.5px",
          fontFamily:
            "'NanumSquareRound', 'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
        },
        "&.swiper-button-disabled": {
          opacity: 1,
          display: "flex",
          "&:after": {
            content: "'메가마트 시작하기'",
          },
        },
      },
    },
    "& .dialog-foot": {
      position: "absolute",
      width: "100%",
      height: rem(80),
      top: "auto",
      bottom: 0,
      left: 0,
      right: 0,
      background: theme.palette.primary.main,
      "& .MuiButton-root": {
        height: rem(80),
        color: theme.palette.common.white,
        fontSize: rem(18),
        fontWeight: 700,
        "& span": {
          fontSize: 0,
        },
      },
    },
  },
}));

export default function DrawerTutorial(props) {
  const { open, handleDialogFullClose } = props;
  const classes = useStyles();

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleDialogFullClose}
      TransitionComponent={Transition}
      className={classes.tutorial}
    >
      <AppBar>
        <Toolbar>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleDialogFullClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          navigation
          pagination={true}
          className="tutorialSwiper mySwiper"
          // allowTouchMove="true"
        >
          <SwiperSlide>
            <dl>
              <dt>홈 화면 설정</dt>
              <dd>
                메가마트 & 메가마켓 매장에서 편리하게
                <br />
                사용 가능한 앱! 홈 화면을 설정해보세요!
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step01.png`}
                style={{ marginLeft: rem(-45) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>단골매장 설정</dt>
              <dd>
                단골매장 설정하고 매장별 단독 혜택에
                <br />
                영업시간, 입점점포까지 편리하게 확인하세요~
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step02.png`}
                style={{ marginRight: rem(-53) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>바코드 열기</dt>
              <dd>
                핸드폰을 두번 좌우로 흔들면
                <br />앱 바코드가 손쉽게 켜져요!
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step03.png`}
                style={{ marginRight: rem(-12) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>간편 결제</dt>
              <dd>
                바코드만 찍어도 바로 간편 결제!
                <br />
                다른 수단으로 결제를 원한다면 옵션을 꺼주세요!
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step04.png`}
                style={{ marginRight: rem(-20) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>간편 결제</dt>
              <dd>
                간편결제 카드 등록은
                <br />
                이곳을 클릭하면 가능!
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step05.png`}
                style={{ marginRight: rem(-20) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>리뷰쓰기</dt>
              <dd>
                전단상품 구매할 때<br />
                리뷰쓰고 포인트 적립은 필수~
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step06.png`}
                style={{ marginRight: rem(-60) }}
              />
            </Box>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>리뷰쓰기</dt>
              <dd>
                리뷰 대상 상품은 메가마트
                <br />
                추천상품에서 바로 확인해보세요!
              </dd>
            </dl>
            <Box className="tutorialImg">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/tutorial-step07.png`}
                style={{ marginRight: rem(-20) }}
              />
            </Box>
            <div className="dialog-foot">
              <Button href="/" fullWidth variant="contained" color="primary">
                <span>메가마트 시작하기</span>
              </Button>
            </div>
          </SwiperSlide>
        </Swiper>
      </DialogContent>
    </Dialog>
  );
}
